// extracted by mini-css-extract-plugin
module.exports = {"item":"creatableItem_item__3k5YR","icon":"creatableItem_icon__n6KAh"};